import {
	FCM_GLOBAL_SHARE_BUTTON_CONFIG,
	FCM_NAFTA_PSF_SHARE_COPY_BANDIT_TRAFFIC_CONFIG,
	FCM_PRIVACY_HIDE_RECRUITER,
	FCM_PSF_SHARE_BUTTON_CONFIG,
	FCM_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE,
	FCM_PSF_SHARE_MESSAGE_BUTTON_ORDER,
} from '@change-corgi/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: PsfSharePageFcmContext,
	FcmProvider: PsfSharePageFcmContextProvider,
	useFcm: usePsfSharePageFcm,
	useAsyncFcm: useAsyncPsfSharePageFcm,
	prefetchFcm: prefetchPsfSharePageFcm,
} = createFcmContext({
	name: 'PsfSharePageFcmContext',
	dataProperty: 'pageFcm',
	configs: {
		copyBanditTrafficConfig: FCM_NAFTA_PSF_SHARE_COPY_BANDIT_TRAFFIC_CONFIG,
		hideRecruiter: FCM_PRIVACY_HIDE_RECRUITER,
		shareButtonsListInitial: FCM_GLOBAL_SHARE_BUTTON_CONFIG,
		shareButtonsListNonInitial: FCM_PSF_SHARE_MESSAGE_BUTTON_ORDER,
		warningMessage: FCM_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE,
		psfOnlyShareButtonList: FCM_PSF_SHARE_BUTTON_CONFIG,
	},
	prefetch: true,
});

export type PsfSharePageFcmState = ReturnType<typeof useAsyncPsfSharePageFcm>;
export type PsfSharePageFcm = LoadedStateData<PsfSharePageFcmState>;
